import { z } from "zod/v4";

export const SettingsSchema = z.object({
	selectedEnvironment: z.string().nullish(),
	selectedAwsProfile: z.string().nullish(),
	// Per-user override for the Moment-Profile sent to secretsproxy. When null
	// or absent, the secrets profile follows `selectedEnvironment` — the common
	// case. Set explicitly when the user wants env + secrets to diverge.
	selectedSecretsProfileOverride: z.string().nullish(),
	// Workspace slug (e.g. "wk-1234") the user has picked for managing/testing
	// secrets while working on a local document. Ignored when the open document
	// already has a remote workspace — that always wins. Nullable when no
	// selection has been made yet.
	selectedSecretsWorkspace: z.string().nullish(),
});

export type Settings = z.infer<typeof SettingsSchema>;
